// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Font-size: 16px = 1em */
.sheet-page-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 100%;
}


/* Music Info 區域 */
.musicInfo-block {
    display: grid;
    grid-template-rows: repeat(6, 1fr);
    /* 設定4行，平均分配高度 */
    grid-template-columns: repeat(30, 1fr);
    /* 設定10列，平均分配寬度 */
    /* 設定網格之間的間距 */
    width: 100%;
    /* 設置容器寬度 */
    height: 75px;
    /* 可調整的容器高度 */
    margin-bottom: 20px;
}

.musicInfo-item {
    outline: none;
    align-items: flex-end;
    position: relative;
}

/* left item */
.musicInfo-item:nth-child(1) {
    font-family: "Verdana";
    grid-column: 2 / span 8;
    grid-row: 1 / span 4;
    font-size: 1.2em;
    align-items: center;
}

/* center item (title)*/
.musicInfo-item:nth-child(2) {
    grid-column: 8 / span 16;
    grid-row: 1 / span 5;
    font-size: 2.5em;

    display: flex;
    align-items: center;
    /* 垂直置中 */
    justify-content: center;
    /* 水平置中 */
    text-align: center;
    /* 文字水平置中 */
    white-space: nowrap;
    /* 禁止換行 */
    overflow: hidden;
    /* 隱藏超出範圍的文字 */
    text-overflow: ellipsis;
    /* 超出範圍的文字顯示省略號 */
}

/* right item */
.musicInfo-item:nth-child(3) {
    font-family: "Verdana";
    grid-column: 25 / span 6;
    grid-row: 4 / span 2;
    font-size: 1.2em;
    /* text-align: center; */
}

/* 提示字元設定 */
.musicInfo-item::before {
    content: attr(data-placeholder);
    /* 使用 data-placeholder 作為提示文字 */
    color: #aaa;
    /* 設置提示文字的顏色 */
    position: absolute;
    /* 絕對定位，使其顯示在容器內 */
    top: 50%;
    /* 垂直居中 */
    left: 50%;
    /* 水平居中 */
    transform: translate(-50%, -50%);
    /* 調整位置，使文字完全居中 */
    pointer-events: none;
    /* 防止提示文字影響用戶操作 */
    white-space: nowrap;
    /* 禁止提示文字換行 */
}

.musicInfo-item:empty::before {
    display: block;
}

.musicInfo-item:not(:empty)::before {
    display: none;
}


/*  there height value .... */
.sheet-block {
    display: flex;
    flex-direction: column;
    color: #333333;
    /* 垂直排列 */
    width: 89%;
    /* 根據需求調整父容器寬度 */
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}

.lable-container {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    height: 5px;
}

.section-label {
    display: flex;
    flex: 1;
    align-items: flex-end;
    outline: none;
    text-align: left;
    padding-top: 10px;
    margin-left: -40px;
    position: relative;
    transform: translateY(50%);
    color: rgba(0, 0, 0, 0.95);
    font-family: "Verdana";
    font-weight: 600;
    font-style: italic;
    text-shadow: 2px 1px 2px #f19dae, -1px -2px 2px #f19dae, 1px -1px 2px #f19dae, -1px 2px 2px #f19dae;
}

.section-label-largest-text {
    font-size: 1.45em;
    margin-left: 5px;
}

.section-label-smallest-text {
    font-size: 1.13em;
}

.chord-container {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    flex-wrap: nowrap;
    min-height: 38px;
    /* 最小高度 */
    max-height: 45px;
    /* 最大高度 */
    height: 45px;
    padding: 0;
    margin: 0;
}

/* Chord */
.chord-container>.chord {
    line-height: 1;
    padding-bottom: 5px;
    display: flex;
    align-items: flex-end;
    font-size: clamp(1.4em, 1.6em, 1.6em);
    flex: 1;

    min-width: 0;
    border: none;
    outline: none;
    box-sizing: border-box;
    /* 超出左邊界一點 */
    margin-left: -10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Chord Word */
.chord-largest-text {
    font-size: 1.45em;
    /* 1.5 倍於 .chord 的字體大小 */
}

/* romanNumera */
.chord-largest-text-number {
    font-size: 1.45em;
    font-family: 'Times New Roman', serif;
    /* 1.5 倍於 .chord 的字體大小 */
}

.chord-larger-text-top {
    font-size: 1em;
    /* 縮小升降記號 */
    line-height: 1;
    /* 行高設置為 1，避免偏移 */
    vertical-align: top;
    /* 對齊到容器頂部 */
    display: inline-block;
    /* 明確設置 inline-block 以便對齊 */
    position: relative;
    top: -0.2em;
    /* 根據實際效果微調 */
}


.chord-larger-text {
    font-size: 1em;
    /* 1.2 倍於 .chord 的字體大小 */
}


.chord-smallest-text {
    font-size: 0.8em;
    /* 0.9 倍於 .chord 的字體大小 */
}

/* Line Setting */
.line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 10px;
    height: 50px;
    min-height: 40px;
    max-height: 50px;
}

.vertical-line {
    min-width: 0;
    width: 2px;
    height: 100%;
    background-color: rgb(29, 29, 29);
}

/* Page Number */
.page-navigation {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    gap: 4px;
}

.prev-button,
.next-button {
    background-color: transparent;
    /* 背景設置為透明 */
    /* 文字顏色設置為藍色（可以根據需要更改） */
    border: 2px solid transparent;
    /* 邊框設置為透明 */
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: bold;
    /* 可以設置字體加粗讓按鈕更顯眼 */
}`, "",{"version":3,"sources":["webpack://./src/styles/content.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,WAAW;AACf;;;AAGA,kBAAkB;AAClB;IACI,aAAa;IACb,kCAAkC;IAClC,gBAAgB;IAChB,sCAAsC;IACtC,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,cAAc;AACd;IACI,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;;IAEhB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,sBAAsB;IACtB,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA,WAAW;AACX;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,SAAS;IACT,SAAS;IACT,gCAAgC;IAChC,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;;AAGA,6BAA6B;AAC7B;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,OAAO;IACP,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mGAAmG;AACvG;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA,UAAU;AACV;IACI,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,qCAAqC;IACrC,OAAO;;IAEP,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,qCAAqC;IACrC,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;;AAGA;IACI,cAAc;IACd,wBAAwB;AAC5B;;;AAGA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,iCAAiC;AACrC;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;;IAEI,6BAA6B;IAC7B,YAAY;IACZ,wBAAwB;IACxB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB","sourcesContent":["/* Font-size: 16px = 1em */\n.sheet-page-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n    width: 100%;\n}\n\n\n/* Music Info 區域 */\n.musicInfo-block {\n    display: grid;\n    grid-template-rows: repeat(6, 1fr);\n    /* 設定4行，平均分配高度 */\n    grid-template-columns: repeat(30, 1fr);\n    /* 設定10列，平均分配寬度 */\n    /* 設定網格之間的間距 */\n    width: 100%;\n    /* 設置容器寬度 */\n    height: 75px;\n    /* 可調整的容器高度 */\n    margin-bottom: 20px;\n}\n\n.musicInfo-item {\n    outline: none;\n    align-items: flex-end;\n    position: relative;\n}\n\n/* left item */\n.musicInfo-item:nth-child(1) {\n    font-family: \"Verdana\";\n    grid-column: 2 / span 8;\n    grid-row: 1 / span 4;\n    font-size: 1.2em;\n    align-items: center;\n}\n\n/* center item (title)*/\n.musicInfo-item:nth-child(2) {\n    grid-column: 8 / span 16;\n    grid-row: 1 / span 5;\n    font-size: 2.5em;\n\n    display: flex;\n    align-items: center;\n    /* 垂直置中 */\n    justify-content: center;\n    /* 水平置中 */\n    text-align: center;\n    /* 文字水平置中 */\n    white-space: nowrap;\n    /* 禁止換行 */\n    overflow: hidden;\n    /* 隱藏超出範圍的文字 */\n    text-overflow: ellipsis;\n    /* 超出範圍的文字顯示省略號 */\n}\n\n/* right item */\n.musicInfo-item:nth-child(3) {\n    font-family: \"Verdana\";\n    grid-column: 25 / span 6;\n    grid-row: 4 / span 2;\n    font-size: 1.2em;\n    /* text-align: center; */\n}\n\n/* 提示字元設定 */\n.musicInfo-item::before {\n    content: attr(data-placeholder);\n    /* 使用 data-placeholder 作為提示文字 */\n    color: #aaa;\n    /* 設置提示文字的顏色 */\n    position: absolute;\n    /* 絕對定位，使其顯示在容器內 */\n    top: 50%;\n    /* 垂直居中 */\n    left: 50%;\n    /* 水平居中 */\n    transform: translate(-50%, -50%);\n    /* 調整位置，使文字完全居中 */\n    pointer-events: none;\n    /* 防止提示文字影響用戶操作 */\n    white-space: nowrap;\n    /* 禁止提示文字換行 */\n}\n\n.musicInfo-item:empty::before {\n    display: block;\n}\n\n.musicInfo-item:not(:empty)::before {\n    display: none;\n}\n\n\n/*  there height value .... */\n.sheet-block {\n    display: flex;\n    flex-direction: column;\n    color: #333333;\n    /* 垂直排列 */\n    width: 89%;\n    /* 根據需求調整父容器寬度 */\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n}\n\n.lable-container {\n    display: flex;\n    justify-content: space-between;\n    box-sizing: border-box;\n    width: 100%;\n    height: 5px;\n}\n\n.section-label {\n    display: flex;\n    flex: 1;\n    align-items: flex-end;\n    outline: none;\n    text-align: left;\n    padding-top: 10px;\n    margin-left: -40px;\n    position: relative;\n    transform: translateY(50%);\n    color: rgba(0, 0, 0, 0.95);\n    font-family: \"Verdana\";\n    font-weight: 600;\n    font-style: italic;\n    text-shadow: 2px 1px 2px #f19dae, -1px -2px 2px #f19dae, 1px -1px 2px #f19dae, -1px 2px 2px #f19dae;\n}\n\n.section-label-largest-text {\n    font-size: 1.45em;\n    margin-left: 5px;\n}\n\n.section-label-smallest-text {\n    font-size: 1.13em;\n}\n\n.chord-container {\n    display: flex;\n    width: 100%;\n    box-sizing: border-box;\n    flex-wrap: nowrap;\n    min-height: 38px;\n    /* 最小高度 */\n    max-height: 45px;\n    /* 最大高度 */\n    height: 45px;\n    padding: 0;\n    margin: 0;\n}\n\n/* Chord */\n.chord-container>.chord {\n    line-height: 1;\n    padding-bottom: 5px;\n    display: flex;\n    align-items: flex-end;\n    font-size: clamp(1.4em, 1.6em, 1.6em);\n    flex: 1;\n\n    min-width: 0;\n    border: none;\n    outline: none;\n    box-sizing: border-box;\n    /* 超出左邊界一點 */\n    margin-left: -10px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* Chord Word */\n.chord-largest-text {\n    font-size: 1.45em;\n    /* 1.5 倍於 .chord 的字體大小 */\n}\n\n/* romanNumera */\n.chord-largest-text-number {\n    font-size: 1.45em;\n    font-family: 'Times New Roman', serif;\n    /* 1.5 倍於 .chord 的字體大小 */\n}\n\n.chord-larger-text-top {\n    font-size: 1em;\n    /* 縮小升降記號 */\n    line-height: 1;\n    /* 行高設置為 1，避免偏移 */\n    vertical-align: top;\n    /* 對齊到容器頂部 */\n    display: inline-block;\n    /* 明確設置 inline-block 以便對齊 */\n    position: relative;\n    top: -0.2em;\n    /* 根據實際效果微調 */\n}\n\n\n.chord-larger-text {\n    font-size: 1em;\n    /* 1.2 倍於 .chord 的字體大小 */\n}\n\n\n.chord-smallest-text {\n    font-size: 0.8em;\n    /* 0.9 倍於 .chord 的字體大小 */\n}\n\n/* Line Setting */\n.line-container {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    box-sizing: border-box;\n    margin-bottom: 10px;\n    height: 50px;\n    min-height: 40px;\n    max-height: 50px;\n}\n\n.vertical-line {\n    min-width: 0;\n    width: 2px;\n    height: 100%;\n    background-color: rgb(29, 29, 29);\n}\n\n/* Page Number */\n.page-navigation {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 10px;\n    gap: 4px;\n}\n\n.prev-button,\n.next-button {\n    background-color: transparent;\n    /* 背景設置為透明 */\n    /* 文字顏色設置為藍色（可以根據需要更改） */\n    border: 2px solid transparent;\n    /* 邊框設置為透明 */\n    border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: bold;\n    /* 可以設置字體加粗讓按鈕更顯眼 */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
